export default function LoadingSpinner({ text = 'Loading...' }: { text?: string }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 gap-6">
      <div className="relative w-20 h-20">
        {/* Glow ring */}
        <div className="absolute inset-0 rounded-full bg-gradient-to-r from-electric-blue/20 to-electric-purple/20 blur-xl animate-pulse" />
        {/* Spinning wheel */}
        <img
          src="/images/sst-wheel.png"
          alt="Loading"
          className="w-full h-full object-contain animate-spin-slow"
        />
      </div>
      <p className="text-sm text-gray-500 font-medium">{text}</p>
    </div>
  )
}
